import { format } from 'date-fns';

export const dateStringToDisplayDate = (dateString: string) => {
  const date = new Date(dateString);

  return format(date, 'MMMM do yyyy');
};

export const dateStringToDisplayDateAndTime = (dateString: string) => {
  const date = new Date(dateString);

  return format(date, 'MMMM do yyyy HH:mm:SS');
};
